module.exports = __webpack_public_path__ + "media/brands/geely-fe26a57e.png";